import * as React from "react"
import { IStep, StepType } from "./StepGuideComponent"
import * as classNames from "classnames"
import { ApplicationSubmitStatusType } from "../../models/enums/ApplicationSubmitStatusType"
import * as FontAwesome from "react-fontawesome"

interface IStepGuideSidebarComponentProps {
    steps: IStep[],
    currentStepNumber: number,
    submittedByCitizen: ApplicationSubmitStatusType,
    onClickStep?: (stepNumber: number) => void,
    isOnClickDisabled?: boolean,
    isAsyncRunning: boolean
}

export default class StepGuideComponent extends React.Component<IStepGuideSidebarComponentProps> {
    constructor(props: IStepGuideSidebarComponentProps) {
        super(props)
    }

    private onStepClicked(step: IStep) {
        if (this.props.isAsyncRunning ||
            this.props.isOnClickDisabled ||
            this.props.onClickStep === undefined) {
            return
        } else {
            this.props.onClickStep(step.id)
        }
    }

    public render(): JSX.Element {
        const {
            steps,
            currentStepNumber,
            submittedByCitizen,
            onClickStep,
            isOnClickDisabled
        } = this.props

        return (
            <div className="row-fluid">
                <ol className="indicator-vertical indicator">
                    {/* For non submitted applications: Select only steps with steptype Step, Confirmation and Receipt */}
                    {(steps && submittedByCitizen === ApplicationSubmitStatusType.NotSubmitted || steps && submittedByCitizen === ApplicationSubmitStatusType.NotSet) && steps.filter(x => x.type === StepType.Step || x.type === StepType.Confirmation || x.type === StepType.Receipt)
                        .map((step) => {
                            const classes = classNames({
                                done: (step.type === StepType.Step && step.completed),
                                final: step.type === StepType.Receipt,
                                current: step.id === currentStepNumber,
                                clickable: !isOnClickDisabled && onClickStep && !(step.type === StepType.Receipt && submittedByCitizen === ApplicationSubmitStatusType.NotSubmitted)
                            })

                            return (
                                <li key={step.id} className={classes} onClick={() => this.onStepClicked(step)} data-ui-test={"step-guide-" + step.uiTestAttribute}>
                                    <div className="title-step">
                                        {step.title}
                                    </div>
                                    <div className="description-step">
                                        {step.shortDescription ? step.shortDescription : ""}
                                    </div>
                                    {((step.type === StepType.Step && step.completed)) && <FontAwesome name="check" style={{ position: "absolute", right: 16, top: 16 }} />}
                                </li>
                            )
                        })}
                    {steps && submittedByCitizen === ApplicationSubmitStatusType.Submitted && steps.filter(x => x.type === StepType.Receipt)
                        .map((step) => {
                            const classes = classNames({
                                done: (step.type === StepType.Step && step.completed) || (step.type === StepType.Confirmation),
                                final: step.type === StepType.Receipt,
                                current: step.id === currentStepNumber,
                                clickable: !isOnClickDisabled && onClickStep && !(step.type === StepType.Receipt && !submittedByCitizen)
                            })

                            return (
                                <li key={step.id} className={classes} onClick={() => this.onStepClicked(step)} data-ui-test={"step-guide-" + step.uiTestAttribute}>
                                    <div className="title-step">
                                        {step.title}
                                    </div>
                                    <div className="description-step">
                                        {step.shortDescription ? step.shortDescription : ""}
                                    </div>
                                    {((step.type === StepType.Receipt && submittedByCitizen === ApplicationSubmitStatusType.Submitted)) && <FontAwesome name="check" style={{ position: "absolute", right: 16, top: 16 }} />}
                                </li>
                            )
                        })}
                    {/* For non submitted applications: Select only steps with steptype Step, Confirmation and Receipt */}
                    {steps && submittedByCitizen === ApplicationSubmitStatusType.NeedsResubmittal && steps.filter(x => x.type === StepType.Resend || x.type === StepType.ResendConfirmation || x.type === StepType.Receipt)
                        .map((step) => {
                            const classes = classNames({
                                done: (step.type === StepType.Resend && step.completed) || (step.type === StepType.Confirmation && submittedByCitizen === ApplicationSubmitStatusType.NeedsResubmittal),
                                final: step.type === StepType.Receipt,
                                current: step.id === currentStepNumber,
                                clickable: !isOnClickDisabled && onClickStep && !(step.type === StepType.Receipt && !submittedByCitizen)
                            })

                            return (
                                <li key={step.id} className={classes} onClick={() => this.onStepClicked(step)} data-ui-test={"step-guide-" + step.uiTestAttribute}>
                                    <div className="title-step">
                                        {step.title}
                                    </div>
                                    <div className="description-step">
                                        {step.shortDescription ? step.shortDescription : ""}
                                    </div>
                                    {((step.type === StepType.Resend && step.completed)) && <FontAwesome name="check" style={{ position: "absolute", right: 16, top: 16 }} />}
                                </li>
                            )
                        })}
                </ol>
            </div>
        )
    }
}